<template>
    <div class="agendamento">
<h2 class="ui header">
    <div class="icone">
          <i class="calendar icon"></i>
          <i class="fas fa-tooth"></i>
          <i class="fas fa-tooth overlay"></i>
    </div>

  <div class="content">
    Marque sua primera consulta. 
    <div class="sub header">Agende via whatsapp !</div>
  </div>
</h2>
        <div class="ui form ">
            <div class="field">
                <input type="text" v-model="form.nome" placeholder="Nome">
            </div>

            <div class="field">
                <input type="text" v-model="form.telefone" placeholder="Telefone">
            </div>
<div class="field">
                <input type="text" v-model="form.email" placeholder="Email" >
            </div>

        
       <div class="inline fields radio">
    <label >Período </label>
    <div class="field">
      <div class="ui radio checkbox">
        <input type="radio" v-model="form.periodo" value="Manha">
        <label>Manhã</label>
      </div>
      <div class="ui radio checkbox">
        <input type="radio" v-model="form.periodo" value="tarde">
        <label>Tarde</label>
      </div>
    </div>
  
  </div>
  <div class="field">
    <textarea rows="3" v-model="form.texto" placeholder="Motivo da consulta"></textarea>
  </div>
<a class="ui button icon" @click="agendar()"><i class="whatsapp icon"></i>Agendar consulta </a>
  </div>
    </div>
</template>

<script>
    export default {
     data() {return {
         form: {
             nome: '',
             telefone: '',
             email: '',
             periodo: '',
             texto: ''
         }
     }},
     methods: {
         agendar() {
                var vm = this;
      var texto = `

*Nome:* %0A
${this.form.nome} %0A
*Telefone:* %0A
${this.form.telefone} %0A
*E-mail:* %0A
${this.form.email} %0A
*Período:* %0A
${this.form.periodo} %0A
*Motivo da consulta:* %0A
_${this.form.texto}_ 
`;
      window.open(
        "https://wa.me/5511948308564?text=" + texto,
        "_blank",
        3000
      );
    },
         }
     }
</script>
